import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import UserService from "services/UserService";
import { postCampaignCopy, putMBMCampaign } from "services/ConfigServices";
import styled from "styled-components";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomSwitch from "components/Input/CustomSwitch.js";
import TextInput from "components/Input/TextInput.js";

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "18px",
    marginRight: "auto",
    marginLeft: "13ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "18px",
    marginRight: "auto",
    marginLeft: "13ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const emailPattern = new RegExp(
  /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i
);

function CampaignDuplicateDialog(props) {
  const memv2versionactive = localStorage.getItem('memv2version') || 0;
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbmadmin = permis.includes("mbm_admin");
  const { closeModal, refetch, setLoading, currentCampaign } = props;
  const [campaign, setCampaign] = useState(currentCampaign || {});
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [name, setName] = useState(campaign?.parameters?.general?.name || "");
  const [stopcampaign, setStopcampaign] = useState("");

  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = advancedSearchContext;

  const handleNameChange = (event) => {
    setName(event.target.value);
  };
  const handleStopCampaignChange = (event) => {
    setStopcampaign(!stopcampaign);
  };

  const handleSubmit = (event) => {
    duplicateCampaign();
  };
  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };
  useEffect(() => {
    if (!name)
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  });

  const duplicateCampaign = async (event) => {

    if(stopcampaign && currentCampaign?.parameters?.general?.status === 'started')
    {
      updateCampaign("stop");
    }

    axios
      .post(
        postCampaignCopy(chartIdGroup),
        {
          id: currentCampaign.id,
          name,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Campagne dupliquée");
          refetch();
          closeModal();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        // setLoading(false);
      });

  }

  const updateCampaign = (action) => {
      const general = {
        ...currentCampaign.parameters.general,
      }
      if (action === 'start') {
        general.status = 'started';
        general.datebegin = moment().format("YYYY-MM-DD");
      }
      else if (action === 'stop') {
        general.status = 'finished';
        general.dateend = moment().format("YYYY-MM-DD");
      }
      const parameters = {
        ...currentCampaign.parameters,
        general,
      }
      axios
        .put(
          putMBMCampaign(currentCampaign.id),
          {
            parameters,

          },
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
              "Content-Type": "application/json; charset=utf-8",
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            setNotification("success", "Campagne modifiée");
            refetch();
          } else setNotification("error", "Une erreur est survenue");
        })
        .catch((error) => {
          setNotification("error", "Une erreur est survenue");
          // setLoading(false);
        });
    
  };

  const classes = useStyles();
  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <CustomSwitch
                style={{ margin: "0.5rem 0rem 0.5rem 1rem" }}
                inputTitle={"Arrêter la campagne actuelle"}
                checkedState={stopcampaign}
                handleSwitchChange={handleStopCampaignChange}
              />
            </div>
            <div>
              <TextInput
                isRequired
                inputTitle={"Nouveau nom"}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
          </GridItem>
        </GridContainer>
      </form>
      <Button
        disabled={buttonDisabled}
        className={
          buttonDisabled
            ? classes.submitButtonDisabled
            : classes.submitButton
        }
        onClick={() => {
          handleSubmit();
        }}
      >
        Dupliquer
      </Button>
    </>
  );
}

export default CampaignDuplicateDialog;
